/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type AppService from 'embercom/services/app-service';
import type RouterService from '@ember/routing/router-service';

export class AskIndexRoute extends Route {
  @service declare appService: AppService;
  @service declare router: RouterService;

  beforeModel() {
    if (!this.appService.app.canUseFeature('team-rec-internal-agent')) {
      this.router.transitionTo('apps.app');
    }
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AskIndexRoute);
